import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { DailyCollectionListing } from './Pages'

export const DailyCollectionRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={DailyCollectionListing} />
    </Fragment>
)